export const fixedTelephoneSave = (area: string | number, main: string | number, exts: string | number): string => {
  let res = ''
  if (main) {
    res = main.toString()
    res = (area ? area.toString() : '') + '|' + res
    res = res + '|' + (exts ? exts.toString() : '')
    return res
  } else {
    return ''
  }
}
